import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctString, FctValue } from '../../../../Fct/generics';
export var Uri = createPlugin({
    protocol: 'ERC1155',
    type: 'GETTER',
    method: 'uri',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc1155' }),
                methodParams: {
                    id: new FctValue({}),
                },
            },
            output: {
                uri: new FctString({ innerIndex: 0 }),
            },
        });
    },
});
